import { useContext, type CSSProperties } from 'react';
import { PageThemeContext } from '@/contexts/pageThemeContextObj';

/**
 * 現在のページテーマ（CSS 変数オーバーライド）を取得する。
 * Provider 配下にない場合は空 object を返す。
 */
export function usePageTheme(): CSSProperties {
  return useContext(PageThemeContext);
}
